import { getWishlist, onWishlistChange } from '@theme/wishlist-store';

// <s-wishlist-count> keeps the header heart badge in step with the local wishlist.
class SWishlistCount extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    onWishlistChange(() => this.#sync(), this.#ac.signal);
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    const count = getWishlist().length;
    const badge = this.querySelector('[data-wishlist-badge]');
    if (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    }
    const link = this.querySelector('a');
    if (link && this.dataset.labelTemplate) link.setAttribute('aria-label', this.dataset.labelTemplate.replace('__COUNT__', String(count)));
  }
}

if (!customElements.get('s-wishlist-count')) customElements.define('s-wishlist-count', SWishlistCount);
